module.exports = __webpack_public_path__ + "static/media/yuuki-asuna-lose.68687a71.png";